import React, { Component } from "react";
import JobPackage from "../../old_Components/Package/JobPackage";
import constant from "../../constant";
import Swal from "sweetalert2";
import {
  PackagesList,
  SubscribedPackageList,
  SubscribePackage,
} from "../../action/package";
import { getStorage } from "../../utils";
import { savePaymentDetail } from "../../action/SubscriptionManagement";
import Loader from "../../old_Components/Common/Loader";

export default class JobPackages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribedList: null,
      packages: undefined,
      showLoader: false,
    };
  }
  componentDidMount() {
    document.title = constant.title.package;
    SubscribedPackageList().then((res) => {
      if (res.status) {
        this.setState({ subscribedList: res.result.all });
      } else {
        console.log(res.error)
      }
    });
  }

  onSubmit = (model) => {
    // this.setState({ showLoader: true });
    SubscribePackage(model).then((res) => {
      this.setState({ showLoader: true });

      if (res.status) {

        const planAmount = model.AMOUNT;
        this.setState({ showLoader: false });

        const options = {
          key: process.env.REACT_APP_RAZOR_KEY,
          amount: planAmount * 100,
          name: "Job Posting Package",
          description: `${model.PACKAGE_TITLE}`,

          handler(razorResponse) {
            const paymentId = razorResponse.razorpay_payment_id;

            if (paymentId) {

              savePaymentDetail({
                SUBSCRIPTION_TXN_ID: res.result.SUBSCRIPTION_TXN_ID,
                PAYMENT_ID: paymentId,
                TXN_STATUS: "SUCCESS",
              }).then((response) => {
                //this.setState({showLoader:false})
                if (response.status) {
                  window.location.href =
                    constant.component.PaymentProcessing.url +
                    "?txn=" +
                    res.result.SUBSCRIPTION_TXN_ID;
                }
              });
            }
          },
          theme: {
            color: "#464646",
          },
        };

        if (model.AMOUNT != 0) {
          const rzp1 = window.Razorpay(options);
          rzp1.open();
        } else {
          Swal.fire({
            text: "Trial plan activated successfully",
            icon: "Success",
          }).then((res) => {
            this.props.history.push(constant.component.Dashboard.url);
          });
        }
      }
      // if (res.status) {
      //   Swal.fire({
      //     icon: 'success',
      //     text: res.result.message,
      //     timer: 1500,
      //     showCancelButton: false,
      //     showConfirmButton: false
      //   })
      //   this.props.history.push(constant.component.Dashboard.url)
      // }
      // else {
      //   Swal.fire({
      //     icon: 'error',
      //     text: res.error,
      //     timer: 1500,
      //     showCancelButton: false,
      //     showConfirmButton: false
      //   })
      // }
    });
  };
  gotoregister = () => {
    this.props.history.push(constant.component.login.url);
  };

  render() {
    const { subscribedList, packages, showLoader } = this.state;

    return (
      <React.Fragment>
        {
          <JobPackage
            packages={packages}
            subscribedList={subscribedList}
            onSubmit={this.onSubmit}
            gotoregister={this.gotoregister}
          />
        }
        {showLoader && <Loader />}
      </React.Fragment>
    );
  }
}
